import { atom } from "recoil";

export const isFeedBackVisibleState = atom<boolean>({
  key: "isFeedBackVisibleState",
  default: false,
});
